export const config = {
  APP_TITLE: import.meta.env.VITE_APP_TITLE,
  API_URL: import.meta.env.VITE_API_URL,
  appName: import.meta.env.VITE_APP_NAME,
  appVersion: import.meta.env.VITE_APP_VERSION,
  isDevelopment: import.meta.env.VITE_APP_ENV === "development",
  isProduction: import.meta.env.VITE_APP_ENV === "production",
  isTest: import.meta.env.VITE_APP_ENV === "test",
};

export const { API_URL } = config;

// export const config = {
//   apiUrl: import.meta.env.VITE_APP_API_URL,
//   environment: import.meta.env.VITE_APP_ENV,
//   appName: import.meta.env.VITE_APP_NAME,
//   appVersion: import.meta.env.VITE_APP_VERSION,
//   isDevelopment: import.meta.env.VITE_APP_ENV === 'development',
//   isProduction: import.meta.env.VITE_APP_ENV === 'production',
//   isTest: import.meta.env.VITE_APP_ENV === 'test',
// };
